import makeStyles from '@mui/styles/makeStyles';
import type { Theme } from '@p81-common/ui';

const createClasses = makeStyles<Theme>(theme => ({
  row: {
    '& .MuiDataGrid-pinnedColumns--right [class="MuiDataGrid-row"]': {
      backgroundColor: theme.palette.common.white,
      clipPath: `inset(${theme.spacing(-1.5, -1.5, 0)})`,
      '& .Mui-hovered': {
        backgroundColor: theme.palette.secondary[100]
      }
    },
    '& .colType--actionButtons': {
      display: 'flex',
      flexDirection: 'row-reverse'
    },
    '& .MuiDataGrid-row--lastVisible': {
      backgroundColor: theme.palette.common.white
    }
  }
}));

export default createClasses;
